import { render } from "./autocomplete.vue?vue&type=template&id=5b7498ca"
import script from "./autocomplete.vue?vue&type=script&lang=js"
export * from "./autocomplete.vue?vue&type=script&lang=js"

import exportComponent from "../../../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"node_modules/@fawmi/vue-google-maps/src/components/autocomplete.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5b7498ca"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5b7498ca', __exports__)) {
    api.reload('5b7498ca', __exports__)
  }
  
  module.hot.accept("./autocomplete.vue?vue&type=template&id=5b7498ca", () => {
    api.rerender('5b7498ca', render)
  })

}


export default __exports__